import { render } from "./ConfirmationBlock.vue?vue&type=template&id=5ec7d0ec&scoped=true"
import script from "./ConfirmationBlock.vue?vue&type=script&lang=js"
export * from "./ConfirmationBlock.vue?vue&type=script&lang=js"

import "./ConfirmationBlock.vue?vue&type=style&index=0&id=5ec7d0ec&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec7d0ec"]])

export default __exports__